import { render } from "./CustomerSizing.vue?vue&type=template&id=3b63d8b4&scoped=true"
import script from "./CustomerSizing.vue?vue&type=script&lang=js"
export * from "./CustomerSizing.vue?vue&type=script&lang=js"

import "./CustomerSizing.vue?vue&type=style&index=0&id=3b63d8b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b63d8b4"]])

export default __exports__